<form class="grid grid-cols-1 sm:grid-cols-2 gap-4" [formGroup]="addressForm">
  @if (fields().addressLine1.visible) {
    <div class="sm:col-span-2 flex flex-col gap-1">
      <p-floatlabel variant="on">
        <textarea
          id="address-line-1"
          pTextarea
          rows="2"
          class="w-full"
          formControlName="addressLine1"
          [invalid]="submitted() && addressForm.controls.addressLine1.invalid"
          (blur)="onFieldTouched()"
        ></textarea>
        <label for="address-line-1"
          >Address Line 1
          @if (fields().addressLine1.required) {
            <span class="text-red-500">*</span>
          }
        </label>
      </p-floatlabel>
      @if (submitted() && addressForm.controls.addressLine1.invalid) {
        <small class="text-xs text-red-600">Address Line 1 is required</small>
      }
    </div>
  }

  @if (fields().addressLine2.visible) {
    <div class="sm:col-span-2 flex flex-col gap-1">
      <p-floatlabel variant="on">
        <input
          id="address-line-2"
          pInputText
          type="text"
          class="w-full"
          formControlName="addressLine2"
          [invalid]="submitted() && addressForm.controls.addressLine2.invalid"
          (blur)="onFieldTouched()"
        />
        <label for="address-line-2"
          >Address Line 2
          @if (fields().addressLine2.required) {
            <span class="text-red-500">*</span>
          }
        </label>
      </p-floatlabel>
      @if (submitted() && addressForm.controls.addressLine2.invalid) {
        <small class="text-xs text-red-600">Address Line 2 is required</small>
      }
    </div>
  }

  @if (fields().cityId.visible) {
    <div class="sm:col-span-2 flex flex-col gap-1">
      <p-floatlabel variant="on">
        <generic-dropdown
          [placeholder]="''"
          [items]="cities()"
          [allowSearch]="true"
          [clearable]="true"
          formControlName="cityId"
        />
        <label for="address-city"
          >City
          @if (fields().cityId.required) {
            <span class="text-red-500">*</span>
          }
        </label>
      </p-floatlabel>
      @if (submitted() && addressForm.controls.cityId.invalid) {
        <small class="text-xs text-red-600">City is required</small>
      }
    </div>
  }

  @if (fields().suite.visible) {
    <div class="flex flex-col gap-1">
      <p-floatlabel variant="on">
        <input
          id="address-suite"
          pInputText
          type="text"
          class="w-full"
          formControlName="suite"
          [invalid]="submitted() && addressForm.controls.suite.invalid"
          (blur)="onFieldTouched()"
        />
        <label for="address-suite"
          >Suite
          @if (fields().suite.required) {
            <span class="text-red-500">*</span>
          }
        </label>
      </p-floatlabel>
      @if (submitted() && addressForm.controls.suite.invalid) {
        <small class="text-xs text-red-600">Suite is required</small>
      }
    </div>
  }

  @if (fields().postalCode.visible) {
    <div class="flex flex-col gap-1">
      <p-floatlabel variant="on">
        <input
          id="address-postal-code"
          pInputText
          type="text"
          class="w-full"
          formControlName="postalCode"
          [invalid]="submitted() && addressForm.controls.postalCode.invalid"
          (blur)="onFieldTouched()"
        />
        <label for="address-postal-code"
          >Postal Code
          @if (fields().postalCode.required) {
            <span class="text-red-500">*</span>
          }
        </label>
      </p-floatlabel>
      @if (submitted() && addressForm.controls.postalCode.invalid) {
        <small class="text-xs text-red-600">Postal Code is required</small>
      }
    </div>
  }

  @if (fields().addressType.visible) {
    <div class="sm:col-span-2 flex flex-col gap-1">
      <p-floatlabel variant="on">
        <generic-dropdown
          [placeholder]="''"
          [items]="addressTypes"
          [allowSearch]="true"
          formControlName="addressType"
        />
        <label for="address-type"
          >Address Type
          @if (fields().addressType.required) {
            <span class="text-red-500">*</span>
          }
        </label>
      </p-floatlabel>
      @if (submitted() && addressForm.controls.addressType.invalid) {
        <small class="text-xs text-red-600">Address Type is required</small>
      }
    </div>
  }
</form>
